module.exports = __webpack_public_path__ + "img/暂无数据.99f944d8.png";